<div id="barChart">
  <div id="bar-chart"></div>
</div>
